require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-la-3-wc.json") })
        }
      }, "path---photos-professional-la-3-wc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-la-3-wc!./.cache/json/photos-professional-la-3-wc.json
// module id = 811
// module chunks = 231608221292675